import { Component, EventEmitter, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-multi-file-upload',
  templateUrl: './multi-file-upload.component.html',
  styleUrls: ['./multi-file-upload.component.scss'],
})
export class MultiFileUploadComponent {
  @ViewChild('attachments') attachment: any;
  @Output() attachments = new EventEmitter<any>();

  fileList: File[] = [];
  listOfFiles: any[] = [];
  isLoading = false;

  onFileChanged(event: any) {
    this.isLoading = true;
    for (var i = 0; i <= event.target.files.length - 1; i++) {
      var selectedFile = event.target.files[i];
      if (this.listOfFiles.indexOf(selectedFile.name) === -1) {
        this.fileList.push(selectedFile);
        this.listOfFiles.push(selectedFile.name);
      }
    }

    this.isLoading = false;
    this.postAttachments(this.fileList);
  }
  postAttachments(fileList) {
    this.attachments.emit(fileList);
  }

  removeSelectedFile(index) {
    this.listOfFiles.splice(index, 1);
    this.fileList.splice(index, 1);
  }
}
